import { I_PatientLocationResponse } from "../api/patient-location.response";

export class C_PatientLocation {
    unitName?: string
    bed?: string
    room?: string

    constructor(json?: I_PatientLocationResponse) {
        if (!json) return;
        this.initialize(json);
    }

    initialize(json?: I_PatientLocationResponse) {
        if (json?.hasOwnProperty('unitName')) this.unitName = json.unitName;
        if (json?.hasOwnProperty('bed')) this.bed = json.bed;
        if (json?.hasOwnProperty('room')) this.room = json.room;
    }

    clone() {
        const clone = new C_PatientLocation();
        clone.unitName = this.unitName;
        clone.bed = this.bed;
        clone.room = this.room;
        return clone
    }

    toInterface(): I_PatientLocationResponse {
        return {
            unitName: this.unitName,
            bed: this.bed,
            room: this.room
        }
    }
}